import { ColumnBib, ColumnRank, ColumnNoc, ColumnName, ColumnResult, ColumnExpander } from "components/common/TableColumns"
import { ColumnJumpDistance, ColumnQualificationMark } from "components/sports/sjp/events/individual/resultsFinal/Columns"
import { ColumnBibTeam } from "../../common/TableColumns"

export function TableColumnsTrialLive() {
    return (
        [
            ColumnBibTeam({}),
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsTrialLiveSM() {
    return (
        [
            ColumnBibTeam({}),
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsTrialFinish() {

    return (
        [
            ColumnBibTeam({}),
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsTrialFinishSM() {

    return (
        [
            ColumnBibTeam({}),
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsQualLive() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsQualLiveSM() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsQualFinish() {

    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsQualFinishSM() {

    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualificationMark({ label: ""}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}